import React from "react";
import Filter from "./Filter";
import LocationSelect from "./LocationSelect";
import Select from "react-select";
import './MainFilterBar.scss';

const MainFilterBar = ({ searchParams, setFilters }) => {
  const accommodationOptions = [
    { value: 'any', label: 'Any' },
    { value: 'semi-private', label: 'Semi-Private' },
    { value: 'private', label: 'Private' }
  ];

  return (
    <div className="MainFilterBar">
      <Filter label="My Location" className="location">
        <LocationSelect
          searchParams={searchParams}
          onChange={(selectedOptions) => {
            setFilters({ zipcode: selectedOptions.map((option) => option.value.trim()).join(',') });
          }}
        />
      </Filter>
      <Filter label="Accommodation Type">
        <Select
          options={accommodationOptions}
          defaultValue={accommodationOptions.find((option) => option.value === (searchParams.get('accommodation_type') || 'any'))}
          onChange={(selectedOption) => {
            setFilters({ accommodation_type: selectedOption.value });
          }}
        />
      </Filter>
    </div>
  );
};

export default MainFilterBar;
